import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    DeleteResourceDiaryRequest,
    DeleteResourceDiaryResponse,
    ResourceDiaryRequest,
    ResourceDiaryResponse,
    UpdateResourceDiaryRequest
} from '../../models/ResourceDiary.model';
import { environment } from '../../environments';

const API_BASE_URL = environment.apiUrl;

// קבלת יומן משאבים
export const getResourceDiary = createAsyncThunk<
    ResourceDiaryResponse,
    ResourceDiaryRequest,
    { rejectValue: string }
>(
    'resourceDiary/getResourceDiary',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_BASE_URL}ResourceDiary/GetResourceDiary`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data: ResourceDiaryResponse = await response.json();

            if (!data.success) return rejectWithValue(data.message || 'Failed to fetch resource diary');
            return data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
        }
    }
);

// יצירת/עדכון יומן משאבים
export const createOrUpdateResourceDiary = createAsyncThunk<
    { success: boolean; message: string; resourceDiaryID: number },
    UpdateResourceDiaryRequest & { resourceName?: string }, // הוסף resourceName
    { rejectValue: string }
>(
    'resourceDiary/createOrUpdateResourceDiary',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_BASE_URL}ResourceDiary/CreateOrUpdateResourceDiary`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: requestData.token,
                    companyKey: requestData.companyKey,
                    projectID: requestData.projectID,
                    resourceID: requestData.resourceID,
                    resourceDiaryID: requestData.resourceDiaryID,
                    startTime: requestData.startTime, // כבר ISO string
                    endTime: requestData.endTime,     // כבר ISO string
                    remarks: requestData.remarks
                }),
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();

            if (!data.success) return rejectWithValue(data.message || 'Failed to create/update resource diary');
            return data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
        }
    }
);
export const deleteResourceDiary = createAsyncThunk<
    DeleteResourceDiaryResponse,
    DeleteResourceDiaryRequest,
    { rejectValue: string }
>(
    'resourceDiary/deleteResourceDiary',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_BASE_URL}ResourceDiary/DeleteResourceDiary`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: requestData.token,
                    companyKey: requestData.companyKey,
                    projectID: requestData.projectID,
                    resourceDiaryID: requestData.resourceDiaryID
                }),
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data: DeleteResourceDiaryResponse = await response.json();

            if (!data.success) return rejectWithValue(data.message || 'Failed to delete resource diary');
            return data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
        }
    }
);